import { convertCell } from '@/common/converter/convert-cell'
import { getCombinedContextList } from '@/common/converter/utils/get-combined-context-list'

/**
 * 구형 cell list 포멧으로 변환
 * @param elementList
 * @returns {Promise<unknown[]>}
 */
export const convertCellList = async (elementList = []) => {
  const contextList = await getCombinedContextList(elementList)

  return contextList.map(convertCell)
}
